module.exports = __webpack_public_path__ + "img/arrow-2.d7911d67.svg";